import { useLocationsForMap } from "@/lib/api";
import theme from "@/styles/theme";
import { Grid, Skeleton } from "@mui/material";
import { LocationCard } from "./network";

const CreateMusicBases = () => {
  const {locations, isLoading, isError} = useLocationsForMap([2]);

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        {locations?.map((location) => {
          return (
            <Grid item xs={12} sm={6} md={4} key={location.id} sx={{ 
              "& > div": {
                backgroundColor: theme.palette.common.white,
              },
              }}>
              <LocationCard location={location} />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default CreateMusicBases;
